import { tv } from "tailwind-variants";

export const filterPanel = tv({
  slots: {
    base: "h-full w-full border-r border-gray-700 gap-[14px] flex flex-col border border-gray-700 bg-gray-800 rounded-[15px]",
    header:
      "min-w-[80px] w-full duration p-4 px-4 flex items-center justify-between text-white-500 w-full justify-between",
    item: "h-fit duration-500 overflow-hidden p-4 gap-4 flex flex-col border-gray-700 border-b last:border-b-0 cursor-pointer",
    hiddeOnClose: "text-muted",
    button: "ml-auto rounded-lg",
  },
  variants: {
    isOpen: {
      true: {
        base: "w-[237px] min-w-[237px] max-w-[237px] bg-gray-800",
        header: "border-b border-gray-700 ",
        hiddeOnClose: "",
        button: "p-4",
      },
      false: {
        base: "!text-white-500 rounded-[10px] h-fit w-fit p-2 hover:bg-gray-700 cursor-pointer",
        header: "!text-white-500 h-fit w-fit p-0",
        hiddeOnClose: "hidden",
        button: "!text-white-500",
      },
    },
  },
});
